var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import VirtualTree from '@patsnap-biz/virtual-tree';
import _ from 'lodash';
import { fieldPtIconMappings, fieldColorList } from './fieldManager';
import '@patsnap-ui/icon/assets/solid/CheckboxOnOutline.svg';
import '@patsnap-ui/icon/assets/solid/TreeHorizontal.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/DropdownRight.svg';
let FieldInfoPopover = class FieldInfoPopover extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.response = null;
        this.fieldData = [];
    }
    get fieldIcon() {
        return fieldPtIconMappings[this.field.fieldType];
    }
    get fieldColor() {
        return fieldColorList[this.field.fieldColor || 0];
    }
    get isListMode() {
        return this.field.fieldType === 'OPTION';
    }
    onShow() {
        this.response = this.getOptionOrLayerFieldInfoPromise(this.field.key) || Promise.reject();
        this.response
            .then((field) => {
            if (field.field_type === 'LAYER') {
                this.fieldData = field.field_layer_value || [];
            }
            else if (field.field_type === 'OPTION') {
                this.fieldData = _.map(field.field_option_value, ({ option_text, option_id }) => {
                    return {
                        name: option_text,
                        id: option_id,
                    };
                });
            }
            if (!this.fieldData.length) {
                console.error(field);
                throw new Error('Field No Data');
            }
            this.loading = false;
        })
            .catch(() => {
            try {
                this.popoverRef.doClose();
            }
            catch (error) {
                console.error(error);
            }
            this.loading = false;
        });
    }
    onTreeMounted() {
        this.$nextTick(() => {
            try {
                setTimeout(() => {
                    this.popoverRef.updatePopper();
                }, 0);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
};
__decorate([
    Prop({ type: Function, })
], FieldInfoPopover.prototype, "getOptionOrLayerFieldInfoPromise", void 0);
__decorate([
    Prop({ type: Object, required: true })
], FieldInfoPopover.prototype, "field", void 0);
__decorate([
    Ref('FieldPopover')
], FieldInfoPopover.prototype, "popoverRef", void 0);
FieldInfoPopover = __decorate([
    Component({
        name: 'FieldInfoPopover',
        components: {
            ElPopover: Popover,
            PtVirtualTree: VirtualTree,
            PtIcon,
        },
    })
], FieldInfoPopover);
export default FieldInfoPopover;
